import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Box, GlobalStyles, styled } from "@mui/material";
import { forwardRef, useState } from "react";
import PerfectScrollbar from "../../external/react-perfect-scrollbar/lib/index.js";
import css from "../../external/react-perfect-scrollbar/dist/css/styles.css.js";
import useOnYReachEnd from "./useOnYReachEnd.js";
import { useYResize } from "./useYResize.js";
import { isMobileDevice } from "../../utils/isMobileDevice.js";
import { spreadSx } from "../../utils/spreadSx.js";
const isMobile = isMobileDevice(), Scrollbar_ = forwardRef(
  ({
    children,
    sx,
    shadow,
    suppressScrollY,
    suppressScrollX,
    options,
    onYResize,
    forceNative,
    onYReachEnd,
    onYReachThreshold,
    containerRef,
    ...props
  }, ref) => {
    const [containerEl, setContainerEl] = useState(null);
    useYResize({ el: containerEl, onResize: onYResize }), useOnYReachEnd({
      el: containerEl,
      threshold: onYReachThreshold,
      onYReachEnd
    });
    const setContainerRef = (el) => {
      setContainerEl(el), containerRef == null || containerRef(el);
    };
    return isMobile || forceNative ? /* @__PURE__ */ jsx(
      Box,
      {
        component: "div",
        sx: [
          styles.mobileScrollbar,
          shadow ? styles.shadows : {},
          suppressScrollX ? styles.suppressScrollX : {},
          suppressScrollY ? styles.suppressScrollY : {},
          ...spreadSx(sx)
        ],
        ref: setContainerRef,
        ...props,
        children
      }
    ) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(GlobalStyles, { styles: css }),
      /* @__PURE__ */ jsx(
        PerfectScrollbar,
        {
          ...props,
          ref,
          containerRef: setContainerRef,
          options: {
            suppressScrollX,
            suppressScrollY,
            minScrollbarLength: 24,
            ...options
          },
          style: { position: "relative", ...props.style },
          children
        }
      )
    ] });
  }
);
Scrollbar_.displayName = "DraftScrollbar";
const Scrollbar = styled(Scrollbar_)(({ theme: t, color = "light", shadow, permanent = !0 }) => ({
  ".ps__thumb-x, .ps__thumb-y": {
    borderRadius: "0!important",
    width: "6px",
    backgroundColor: `${color === "light" ? t.palette.scroll.light.handle.default : t.palette.scroll.dark.handle.default}!important`,
    "@media(hover:hover)": {
      "&:hover": {
        backgroundColor: color === "light" ? t.palette.scroll.light.handle.hover : t.palette.scroll.dark.handle.hover
      }
    }
  },
  ".ps__thumb-x": {
    bottom: 0
  },
  ".ps__thumb-y": {
    right: 0
  },
  ".ps__rail-x, .ps__rail-y": {
    backgroundColor: "transparent!important",
    width: "6px"
  },
  ".ps__rail-y": {
    opacity: permanent ? "1!important" : void 0
  },
  ...shadow && styles.shadows
})), styles = {
  mobileScrollbar: {
    overflowY: "auto"
  },
  suppressScrollX: {
    overflowX: "hidden"
  },
  suppressScrollY: {
    overflowY: "hidden"
  },
  shadows: {
    overflowScrolling: "touch",
    background: `linear-gradient(
      white 30%,
      rgba(255, 255, 255, 0)
    ) center top,
    
    /* Shadow Cover BOTTOM */
    linear-gradient(
      rgba(255, 255, 255, 0), 
      white 70%
    ) center bottom,
    
    /* Shadow TOP */
    radial-gradient(
      farthest-side at 50% 0,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0)
    ) center top,
    
    /* Shadow BOTTOM */
    radial-gradient(
      farthest-side at 50% 100%,
      rgba(0, 0, 0, 0.1),
      rgba(0, 0, 0, 0)
    ) center bottom`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 40px, 100% 40px, 150% 10px, 150% 10px",
    backgroundAttachment: "local, local, scroll, scroll"
  }
};
export {
  Scrollbar
};
//# sourceMappingURL=Scrollbar.js.map
